import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { isClinro, isPreview } from '@/config';
import { useQuestionnaire } from '@/store';
import { MessageType } from '@/types';
import { addQbMocks, handleQbReset } from '@/utils/qbPreview';
import { useEffect } from 'react';
import { Icon } from './Icon';
export const GeneralErrorModal = ({ resetErrorBoundary }) => {
    const { t } = useTranslation();
    const questCtx = useQuestionnaire();
    useEffect(() => {
        const handleMessage = (event) => {
            if (isPreview && Object.values(MessageType).includes(event.data.type)) {
                resetErrorBoundary();
                handleQbReset(questCtx, event.data);
                addQbMocks(questCtx, event.data);
            }
        };
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [resetErrorBoundary]);
    return (_jsxs(Modal, Object.assign({ isCentered: true, isOpen: true, onClose: null, size: 'xl' }, { children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, Object.assign({ alignItems: 'center', backgroundColor: 'white', p: '30px', textAlign: 'center' }, { children: [_jsxs(ModalHeader, { children: [_jsx(Icon, { color: 'red.80', m: 'auto', name: 'exclamation-circle', size: '30px', type: 'solid' }), _jsx(Text, Object.assign({ fontSize: '24px', fontWeight: '500', mt: '4' }, { children: t('common:message.error.default') }))] }), !isClinro && (_jsx(ModalFooter, Object.assign({ gridGap: '8' }, { children: _jsx(Button, Object.assign({ onClick: () => window.location.reload() }, { children: t('app:components.common.refresh') })) })))] }))] })));
};
